import { render, staticRenderFns } from "./ringInfo.vue?vue&type=template&id=181b9a3e&scoped=true&"
import script from "./ringInfo.vue?vue&type=script&lang=js&"
export * from "./ringInfo.vue?vue&type=script&lang=js&"
import style0 from "./ringInfo.vue?vue&type=style&index=0&id=181b9a3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181b9a3e",
  null
  
)

export default component.exports